// import React from "react";
// import PopOverMenu from "../pop-over-menu/pop-over-menu";
// import styles from "./style.module.css";
// import { convertTo12HourFormat, formatUtcToLocalTime } from "../../helper";
// import Loader from "../loader";
// import { MONTHLY_TYPE, STATUS_AVAILABLE } from "../../constants";

// const TeacherSlots = ({
//   onSelect,
//   selectedSlots,
//   slots,
//   loading,
//   offerDetail,
//   onSelectSameSlots,
//   onCheckAllSameDaySlots,
// }) => {
//   console.log("all slots", slots);
//   const weekDays = [
//     "Sunday",
//     "Monday",
//     "Tuesday",
//     "Wednesday",
//     "Thursday",
//     "Friday",
//     "Saturday",
//   ];

//   const renderSlots = (allSlots) => {
//     if (!allSlots) return "No allSlots available";
//     return allSlots?.map((slot, index) => {
//       return (
//         <span key={`slot-${index}`} className="d-block border-bottom py-2">
//           <span className="d-block">
//             <input
//               className="me-2"
//               disabled={slot.status !== STATUS_AVAILABLE}
//               type="checkbox"
//               checked={
//                 selectedSlots?.find((item) => item?.uuid === slot?.uuid)
//                   ? true
//                   : false
//               }
//               onChange={(e) => onSelect(e, slot)}
//             />{" "}
//             <span
//               className={`text-capitalize badge ${
//                 slot.status !== STATUS_AVAILABLE ? "bg-danger" : "bg-success"
//               }`}
//               style={{ fontFamily: "poppins" }}
//             >{`${slot?.status}`}</span>
//           </span>
//           <span className="d-block">{`${formatUtcToLocalTime(
//             slot?.startTime
//           )} - ${formatUtcToLocalTime(slot?.endTime)}`}</span>

//           {offerDetail?.offerType === MONTHLY_TYPE && (
//             <span className="d-block" style={{ fontFamily: "poppins" }}>
//               <input
//                 className="me-2"
//                 disabled={slot.status !== STATUS_AVAILABLE}
//                 type="checkbox"
//                 checked={
//                   slot.status === STATUS_AVAILABLE &&
//                   onCheckAllSameDaySlots(slot)
//                 }
//                 onChange={(e) => onSelectSameSlots(e, slot)}
//               />{" "}
//               Book for all {slot?.dayName}
//             </span>
//           )}
//         </span>
//       );
//     });
//   };

//   return loading ? (
//     <div className={`custom_text_center ${styles["container"]}`}>
//       <Loader />
//     </div>
//   ) : slots?.length ? (
//     <>
//       <div className="table-responsive">
//         <table className="table table-bordered">
//           <thead className="thead-dark">
//             <tr>
//               <th>Days</th>
//               {weekDays.map((day, index) => (
//                 <th key={index}>{day}</th>
//               ))}
//             </tr>
//           </thead>
//           <tbody className="border">
//             {slots?.map((item, rowIndex) => (
//               <tr key={rowIndex}>
//                 <td>{rowIndex + 1}</td>
//                 {Object.entries(item).map(([date, slots], colIndex) => (
//                   <td
//                     key={colIndex}
//                     className={`${
//                       !slots || !slots?.length
//                         ? "text-body-tertiary cursor-not-allowed"
//                         : ""
//                     }${
//                       slots?.some((item1) =>
//                         selectedSlots?.some(
//                           (item2) => item1?.uuid === item2?.uuid
//                         )
//                       )
//                         ? "text-green"
//                         : ""
//                     }`}
//                   >
//                     <span className="d-block font-size-13px">{date}</span>
//                     <span className="d-block font-size-13px cursor_pointer">
//                       {slots?.length ? (
//                         <u>
//                           <PopOverMenu
//                             placement="bottom"
//                             content={
//                               <div className={styles["content"]}>
//                                 {renderSlots(slots)}
//                               </div>
//                             }
//                             button={<span>View Slots</span>}
//                           />
//                         </u>
//                       ) : (
//                         ""
//                       )}
//                     </span>
//                   </td>
//                 ))}
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </>
//   ) : (
//     <div className={`custom_text_center ${styles["container"]}`}>
//       No slots to display.
//     </div>
//   );
// };

// export default TeacherSlots;

import React from "react";
import { Popover, Button, Checkbox, Badge, Table, Spin } from "antd";
import { CalendarOutlined, ClockCircleOutlined } from "@ant-design/icons";
import styles from "./style.module.css";
import { convertTo12HourFormat, formatUtcToLocalTime } from "../../helper";
import { MONTHLY_TYPE, STATUS_AVAILABLE } from "../../constants";

const TeacherSlots = ({
  onSelect,
  selectedSlots,
  slots,
  loading,
  offerDetail,
  onSelectSameSlots,
  onCheckAllSameDaySlots,
}) => {
  // console.log("all slots", slots);

  const weekDays = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const renderSlots = (allSlots) => {
    if (!allSlots || allSlots.length === 0) {
      return <div className={styles["no-slots"]}>No slots available</div>;
    }

    return (
      <div className={styles["slots-container"]}>
        {allSlots?.map((slot, index) => (
          <div key={`slot-${index}`} className={styles["slot-item"]}>
            <div className={styles["slot-header"]}>
              <Checkbox
                disabled={slot.status !== STATUS_AVAILABLE}
                checked={selectedSlots?.some(
                  (item) => item?.uuid === slot?.uuid
                )}
                onChange={(e) => {
                  e.stopPropagation(); // Prevent event bubbling
                  onSelect(e, slot);
                }}
              />
              <Badge
                status={slot.status === STATUS_AVAILABLE ? "success" : "error"}
                text={
                  <span className={styles["status-text"]}>{slot?.status}</span>
                }
              />
            </div>

            <div className={styles["time-info"]}>
              <ClockCircleOutlined className={styles["time-icon"]} />
              <span>
                {formatUtcToLocalTime(slot?.startTime)} -{" "}
                {formatUtcToLocalTime(slot?.endTime)}
              </span>
            </div>

            {offerDetail?.offerType === MONTHLY_TYPE && (
              <div className={styles["monthly-option"]}>
                <Checkbox
                  disabled={slot.status !== STATUS_AVAILABLE}
                  checked={
                    slot.status === STATUS_AVAILABLE &&
                    onCheckAllSameDaySlots(slot)
                  }
                  onChange={(e) => {
                    e.stopPropagation(); // Prevent event bubbling
                    onSelectSameSlots(e, slot);
                  }}
                >
                  <span className={styles["book-all-text"]}>
                    Book for all {slot?.dayName}
                  </span>
                </Checkbox>
              </div>
            )}
          </div>
        ))}
      </div>
    );
  };

  const getPopoverContent = (slots) => {
    return (
      <div className={styles["popover-content"]}>{renderSlots(slots)}</div>
    );
  };

  const tableColumns = [
    {
      title: "Weeks",
      dataIndex: "week",
      key: "week",
      width: 80,
      align: "center",
      render: (text, record, index) => (
        <div className={styles["week-number"]}>{index + 1}</div>
      ),
    },
    ...weekDays.map((day, dayIndex) => ({
      title: day,
      dataIndex: day.toLowerCase(),
      key: day.toLowerCase(),
      width: 100,
      align: "center",
      render: (text, record) => {
        const dateEntries = Object.entries(record).filter(
          ([key]) => key !== "key"
        );
        const dayEntry = dateEntries[dayIndex];

        if (!dayEntry) {
          return (
            <div className={styles["date-cell"]}>
              <span className={styles["no-slots-text"]}>No slots</span>
            </div>
          );
        }

        const [dateKey, dateSlots] = dayEntry;
        const hasSlots = dateSlots && dateSlots.length > 0;
        const hasSelectedSlots =
          hasSlots &&
          dateSlots?.some((slot) =>
            selectedSlots?.some((selected) => selected?.uuid === slot?.uuid)
          );

        return (
          <div className={styles["date-cell"]}>
            <div className={styles["date-display"]}>
              <span className={styles["date-text"]}>{dateKey}</span>
            </div>

            {hasSlots ? (
              <Popover
                content={getPopoverContent(dateSlots)}
                title={`Available Slots - ${dateKey}`}
                placement="bottomLeft"
                trigger="click"
                overlayClassName={styles["slots-popover"]}
              >
                <Button
                  type="link"
                  size="small"
                  className={`${styles["view-slots-btn"]} ${
                    hasSelectedSlots ? styles["has-selected"] : ""
                  }`}
                >
                  View Slots
                </Button>
              </Popover>
            ) : (
              <span className={styles["no-slots-text"]}>No slots</span>
            )}
          </div>
        );
      },
    })),
  ];

  const tableData =
    slots?.map((item, index) => ({
      key: index,
      ...item,
    })) || [];

  if (loading) {
    return (
      <div className={styles["loading-container"]}>
        <Spin size="large" />
        <p>Loading slots...</p>
      </div>
    );
  }

  if (!slots?.length) {
    return (
      <div className={styles["empty-container"]}>
        <CalendarOutlined className={styles["empty-icon"]} />
        <h4 className="poppins">No slots available</h4>
        <p className="poppins">
          Please check back later for available time slots.
        </p>
      </div>
    );
  }

  return (
    <div className={styles["teacher-slots-wrapper"]}>
      <Table
        columns={tableColumns}
        dataSource={tableData}
        pagination={false}
        scroll={{ x: 600, y: 200 }}
        className={styles["slots-table"]}
        bordered
        size="small"
      />
    </div>
  );
};

export default TeacherSlots;
